import React from "react"
import { Container } from "semantic-ui-react"
import ItemBlogSmall from "../components/Blogs/ItemBlogSmall/ItemBlogSmall"

const Blog = () => {
  return (
    <div className='container-Sections'>
      <Container className='locationDisplayNavbar'>
        <div className='row'>
          <ItemBlogSmall />
        </div>
      </Container>
    </div>
  )
}

export default Blog
